<template>
  <header>
    <nav-bar/>
  </header>

    <router-view></router-view>

</template>

<script>
import NavBarBar from '@/components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar: NavBarBar
  }
}
</script>

<style>
#app {
  font-family: "Poppins", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
